<template>
  <div class="h6 mb-0" v-if="lamp.emer_active=='EMERGENZA IN CORSO'" :content="$t('details_lamp.lamp_emergency_running')" v-tippy="{ placement: 'top', arrow: true }">
       
        <!---- gestione emergenza -->
        <div>
            <b-iconstack :font-scale="scale">
              <b-icon stacked icon="plug" style="color: orange;" scale="1"></b-icon>
              <b-icon stacked icon="lightning-fill"  scale="0.5" style="color: white;"></b-icon> 
              <b-icon stacked icon="circle"  scale="1" style="color: orange ;"></b-icon>      
           </b-iconstack>
           <!-- <b-iconstack v-else font-scale="1">
              <b-icon stacked icon="plug" style="color: orange;" scale="1"></b-icon>
              <b-icon stacked icon="lightning-fill"  scale="0.5" style="color: white;"></b-icon> 
              <b-icon stacked icon="circle"  scale="1" style="color: orange ;"></b-icon>      
           </b-iconstack> -->
        </div>

  </div>
</template>

<script>

export default {
  name: "IconEmergencyOn",
  props: {
    lamp: {
      default: null
    },
    scale: {
      type: String,
      default: "2.5"
    }
  },
  data() {
    return {
    };
  },
    
   
  }
  
</script>
